import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Activate dark theme for shadcn/ui components
document.documentElement.classList.add('dark');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
